import { trialDaysLeft } from '@kontor/shared';
import { Link } from 'react-router';
import { useSession } from '../session';
import './trialnotice.css';

const CONTACT = 'kontakt@wirkia.de';
const stamp = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });

/**
 * Hinweis in der Testphase (KON-177): Resttage und Ende, ab fünf Tagen auffälliger. Wer bestellen darf (Recht „Abrechnung“, der Inhaber), kommt von hier zur Bestellung
 * (KON-180), alle anderen sehen die Adresse, an die sie schreiben können.
 */
export function TrialNotice() {
  const { session, can } = useSession();
  const tenant = session?.tenant;
  if (!tenant?.trial || !tenant.validUntil) return null;
  const days = trialDaysLeft(tenant.validUntil);
  const end = stamp.format(new Date(tenant.validUntil)).replace(',', '');
  const urgent = days <= 5;
  return (
    <div className={`trialnotice${urgent ? ' trialnotice--urgent' : ''}`} role="status">
      <strong>{days <= 1 ? 'Ihre Testphase endet heute oder morgen.' : `Testphase: noch ${days} Tage.`}</strong>{' '}
      <span>Sie endet am {end} Uhr. Danach wird der Zugang gesperrt, und ohne Bestellung löschen wir Ihre Daten. {can('setup.billing') ? (
          <>Wollen Sie weitermachen? <Link to="/bestellen">Paket bestellen</Link>. Ihre Daten bleiben dabei erhalten.</>
        ) : (
          <>Zum Bestellen wenden Sie sich an den Inhaber oder schreiben Sie an <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.</>
        )}</span>
    </div>
  );
}
